import { useState } from 'react';

import CheckIcon from '@mui/icons-material/Check';
import LanguageIcon from '@mui/icons-material/Language';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { type Locale, getLocale, locales, setLocale } from '@/paraglide/runtime.js';

const LOCALE_NAMES: Record<Locale, string> = {
  cs: 'Čeština',
  sk: 'Slovenčina',
  en: 'English',
};

export function LocaleSelector() {
  const currentLocale = getLocale();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        aria-label="Select language"
        sx={{ color: 'text.secondary' }}
      >
        <LanguageIcon fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { minWidth: 150, mt: 0.5 } } }}
      >
        {(locales as readonly Locale[]).map((locale) => (
          <MenuItem
            key={locale}
            selected={locale === currentLocale}
            onClick={() => {
              setLocale(locale);
              setAnchorEl(null);
            }}
            sx={{ gap: 1.5, fontSize: 14 }}
          >
            <CheckIcon
              fontSize="small"
              sx={{
                visibility: locale === currentLocale ? 'visible' : 'hidden',
                color: 'primary.main',
              }}
            />
            {LOCALE_NAMES[locale]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
